import React, {useState, useEffect} from "react";
import {useParams, useNavigate} from "react-router-dom";

import styles from "./IndividualNews.module.css";
import axios from "axios";
import {imageArray} from "./NewsData";

//mui components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import Chip from "@mui/material/Chip";

import NurseImage from "../../assets/images/NewsNursesImage.png";
import NurseImage1 from "../../assets/images/NurseImage1.png";
import Newsimage from "../../assets/images/newsimage1.png";
import {hover} from "@testing-library/user-event/dist/hover";

const newsPath = "/News";

function IndividualNews() {
	const navigate = useNavigate();
	const {heading} = useParams();
	const [newsMediaData, setNewsMediaData] = useState([]);

	const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
	const fetchDepartmentDataApi = async () => {
		try {
			const response = await axios.get(`${apiBaseUrl}/api/newsMedia/getAll`);
			setNewsMediaData(response?.data?.data);
			return response?.data?.data;
		} catch (error) {
			throw Error("Error while fetching data", error);
		}
	};

	useEffect(() => {
		fetchDepartmentDataApi();
	}, []);

	const individualNews = newsMediaData.find(
		(news) => news.Headline === heading
	);
	const removeCurrentNews = newsMediaData.filter((x) => x.Headline !== heading);
	const suggestionNews = removeCurrentNews
		.sort(() => Math.random() - Math.random())
		.slice(0, 5);
	const individualNewsImages = imageArray.find(
		(news) => news?.heading === heading
	);

	const onClickNews = (heading) => {
		navigate(`/newsandmedia/${heading}`);
	};

	if (!individualNews) {
		// Handle the case when 'name' doesn't match any data
		return (
			<Grid style={{width: "90%", marginTop: "70px"}}>News not found</Grid>
		);
	}

	return (
		<Container
			component="main"
			maxWidth={false}
			style={{width: "90%", marginTop: "170px"}}
			className={styles.container}
		>
			<Grid container spacing={6}>
				<Grid
					item
					xs={12}
					sm={12}
					md={12}
					lg={10}
					display="flex"
					flexDirection="column"
					//   alignItems="center"
					//   justifyContent="center"
				>
					<Typography
						color="#747474"
						fontFamily="Inter"
						fontSize="18px"
						fontStyle="normal"
						fontWeight="400"
						// marginTop="10px"
					>
						{individualNews?.Date}
					</Typography>
					<Typography
						color="var(--dark, #211E1E)"
						fontFamily="Inter"
						fontSize="35px"
						fontStyle="normal"
						fontWeight="400"
						// marginTop="10px"
					>
						{individualNews.FirstPara}
					</Typography>
					{/* <Typography
            color="var(--dark, #211E1E)"
            fontFamily="Inter"
            fontSize="18px"
            fontStyle="normal"
            fontWeight="400"
            marginTop="10px"
          >
            {individualNews.FirstPara}
          </Typography> */}
					<Grid>
						<img
							src={`${newsPath}/NewsCover/${individualNews.Headline}.jpg`}
							alt=""
							className={styles.mainImage}
						/>
					</Grid>
					<Typography
						color="var(--dark, #211E1E)"
						fontFamily="Inter"
						fontSize="18px"
						fontStyle="normal"
						fontWeight="400"
						marginTop="10px"
					>
						{/* <p>A Glorious Tribute to the Guardians of Care</p>
            <p>With utmost joy and admiration, we commemorated the Day of Angels, International Nursing Day, in an unforgettable ceremony. Our esteemed Managing Director, the distinguished Dr. Sheeja G Manoj, graced the occasion with her presence, infusing the event with brilliance. Joining us as the esteemed Chief Guest was the remarkable Mrs. Gayatri Subhash, the illustrious Managing Director of BHIMA Jewellers. Special Thanks to <a href="https://www.facebook.com/Tanishq/?__cft__[0]=AZVSxgRGuWbr7KXnmXnOWUzWlsSyIpL9jWioyf_Cq7KfX02T_910CRzAxdyx72-aAVAYJduDWaMoMFkupnsEZgwXTr6wTky86UtPRtNMEvqsuW96xeDLFPLKfAr869mAr-wS7GcIuUPFPtQZZ-VIEKutzqXSBbQccpf-uBQJnF5kmf1l10uJzNDAPMDDkQWerYk&amp;__tn__=kK-R">Tanishq</a> for the gifts and for sending wishes to our angels.</p>
            <p>We extend our heartfelt gratitude to Mrs. Gayatri Subhash and the dedicated staff of <a href="https://www.facebook.com/bhimatvm/?__cft__[0]=AZVSxgRGuWbr7KXnmXnOWUzWlsSyIpL9jWioyf_Cq7KfX02T_910CRzAxdyx72-aAVAYJduDWaMoMFkupnsEZgwXTr6wTky86UtPRtNMEvqsuW96xeDLFPLKfAr869mAr-wS7GcIuUPFPtQZZ-VIEKutzqXSBbQccpf-uBQJnF5kmf1l10uJzNDAPMDDkQWerYk&amp;__tn__=kK-R">Bhima Jewellery</a>, who magnanimously bestowed gifts upon our exceptional nurses, symbolizing their deep appreciation for their invaluable contributions. This generous gesture resonated with the profound gratitude we hold for these angelic caregivers.</p>
            <p>A noteworthy mention is owed to the dynamic presence of <a href="https://www.facebook.com/REDFMMALAYALAM/?__cft__[0]=AZVSxgRGuWbr7KXnmXnOWUzWlsSyIpL9jWioyf_Cq7KfX02T_910CRzAxdyx72-aAVAYJduDWaMoMFkupnsEZgwXTr6wTky86UtPRtNMEvqsuW96xeDLFPLKfAr869mAr-wS7GcIuUPFPtQZZ-VIEKutzqXSBbQccpf-uBQJnF5kmf1l10uJzNDAPMDDkQWerYk&amp;__tn__=kK-R">Red FM Malayalam</a> RJ Chinchu and her team, who added vibrant hues of enthusiasm and energy to the ambience, amplifying the significance of this momentous occasion.</p>
            <p>On this day, we recognized the extraordinary devotion and unwavering spirit of our nurses, who embody the very essence of compassion and selflessness. Their commitment to healing and nurturing reflects the epitome of noble service.</p>
            <p>May the radiance of this event continue to shine as a testament to the profound impact our nurses have on the lives they touch, and may their selfless dedication forever inspire others to embrace the noble calling of healthcare.</p>
            <p>Happy International Nursing Day!</p> */}
						{individualNews.SecondPara}
					</Typography>
					<Grid container spacing={2} marginTop="20px">
						{individualNewsImages?.subImages.map((images, index) => (
							<Grid
								item
								xs={12}
								sm={12}
								md={12}
								lg={6}
								display="flex"
								flexDirection="column"
								alignItems="center"
								justifyContent="center"
							>
								{" "}
								<img
									src={images?.image}
									alt=""
									className={styles.mainImage}
									width="300px"
									height="400px"
								/>
							</Grid>
						))}
					</Grid>
				</Grid>
				{/* Suggestion of news media starts */}
				<Grid
					item
					xs={12}
					sm={12}
					md={12}
					lg={2}
					display="flex"
					flexDirection="column"
					//   alignItems="center"
					//   justifyContent="center"
					marginTop="50px"
				>
					<Grid container spacing={3}>
						{suggestionNews.map((news, index) => (
							<Grid
								item
								xs={12}
								sm={12}
								md={12}
								lg={12}
								display="flex"
								flexDirection="column"
								//   alignItems="center"
								justifyContent="center"
							>
								<Grid
									sx={{cursor: "pointer"}}
									display="flex"
									flexDirection="column"
									//   alignItems="center"
									justifyContent="center"
								>
									<img src={`/News/NewsCover/${news.Headline}.jpg`} alt="" />
									<Typography
										color="#747474"
										fontFamily="Inter"
										fontSize="18px"
										fontStyle="normal"
										fontWeight="400"
										// marginTop="10px"
									>
										{news.Date}
									</Typography>

									<Typography
										color="var(--dark, #211E1E)"
										fontFamily="Inter"
										fontSize="18px"
										fontStyle="normal"
										fontWeight="500"
										// marginTop="10px"
										onClick={() => {
											onClickNews(news.Headline);
										}}
									>
										{news.Headline}
									</Typography>
								</Grid>
							</Grid>
						))}
					</Grid>
				</Grid>
				{/* suggestion of news media end here */}
			</Grid>
		</Container>
	);
}

export default IndividualNews;
